<template>
	<div class="tabMail">
		<div class="fieldGroup">
			<div class="fieldTitle">Mail</div>
			<field
					:classError="getError('mailHostValidations')"
					width="390px"
					margin="0 0 10px 0"
					label="Host"
					placeholder="Host"
					@updateInput="onInput($event, 'MAIL_HOST')"
					:setInputValue="mailHost"
					is-required
			></field>
			<field
					:classError="getError('mailPortValidations')"
					margin="0 0 10px 0"
					width="390px"
					label="Port"
					placeholder="Port"
					@updateInput="onInput($event, 'MAIL_PORT')"
					:setInputValue="mailPort"
					is-required
			></field>
			<field
					:classError="getError('mailUserNameValidations')"
					margin="0 0 10px 0"
					width="390px"
					label="Username"
					placeholder="User name"
					@updateInput="onInput($event, 'MAIL_USERNAME')"
					:setInputValue="mailUserName"
					is-required
			></field>
			<field
					:classError="getError('mailPasswordValidations')"
					margin="0 0 10px 0"
					width="390px"
					label="Password"
					placeholder="Password"
					@updateInput="onInput($event, 'MAIL_PASSWORD')"
					:setInputValue="mailPassword"
					is-required
			></field>
		</div>
	</div>
</template>

<script>

export default {
	name: "Mail",
	props: {
		valid: Object,
		mailHost: String,
		mailPort: String,
		mailUserName: String,
		mailPassword: String,
	},
	methods: {
		getError(key) {
			return this.valid[key]?.$error;
		},
		onInput({ value }, key) {
			this.$emit('updateMail', { value, key });
		},
	}
};
</script>
